import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { getClientId } from '~/services/auth';
import { IThunkResendCode } from '../types';

const onResendCode: IThunkResendCode = thunk(
  // @ts-ignore
  async ({ setIsMfaRequired }, payload) => {
    const clientId = getClientId();

    const data = await api.auth
      .resendCode({
        clientId,
        mfaTypeId: payload,
      })
      .then(x => x.data);

    setIsMfaRequired(data);
  },
);

export default onResendCode;
